<template>
    <PageView>
        <a-card title="列表">
            <a-row :gutter="10" class="inputGroup">
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.username" placeholder="请输入昵称" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.phone" placeholder="请输入手机号" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.name" placeholder="请输入姓名" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-button-group>
                        <a-button type="primary" :loading="loading" @click="getList">确定筛选</a-button>
                    </a-button-group>
                    <a-button-group style="margin-left:10px">
                        <a-button type="primary" :loading="loading" @click="getListInit">重置</a-button>
                    </a-button-group>
                </a-col>
            </a-row>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
            <!-- <a-button type="primary" @click="exportExcel" style="float: right">导出表格</a-button> -->
        </a-card>
		<a-modal v-model="visible" title="查看图片" @ok="visible = false">
		    <img :src="viewImg" style="width: 100%;" alt="" />
		</a-modal>
        <a-modal
            title="修改个人信息"
            :visible="Password"
            centered
            :closable="false"
            :maskClosable="false"
            width="460px"
        >
            <div>昵称:</div>
            <a-input v-model="lent.username" placeholder="请输入昵称" style="margin: 10px 0" />
            <!-- <div>姓名:</div>
            <a-input v-model="lent.name" placeholder="请输入姓名" style="margin: 10px 0" /> -->
            <div>手机号:</div>
            <a-input v-model="lent.phone" placeholder="请输入手机号" style="margin: 10px 0" />
			<a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
			    <span> <span style="color:red">*</span> 身份证正面图片:</span>
			    <a-row :gutter="10" class="inputGroup" style="margin-bottom: 20px" type="flex"
			        justify="space-around" align="middle">
			        <a-col :xs="12" :md="8" :lg="8" :xl="10">
			            <div class="imgContaienr">
			                <div class="con">
								
<img 
  v-if="lent.real_zheng !== ``" 
  :src="lent.real_zheng" 
  style="width: 100px; height: 90px; cursor: pointer"
  @click="handlePreview(lent.real_zheng)"
/>			                    <a v-else class="placeText">请选择图片</a>
			                </div>
			            </div>
			        </a-col>
			        <a-col :xs="24" :md="8" :lg="8" :xl="14">
			            <div class="btnCon">
			                <input @change="handleChange" type="file" accept="image/*" />
			                <a-button-group>
			                    <a-button type="primary">选择图片</a-button>
			                </a-button-group>
			            </div>
			        </a-col>
			    </a-row>
			</a-form-item>
		<a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
		    <span> <span style="color:red">*</span> 身份证反面图片:</span>
		    <a-row :gutter="10" class="inputGroup" style="margin-bottom: 20px" type="flex"
		        justify="space-around" align="middle">
		        <a-col :xs="12" :md="8" :lg="8" :xl="10">
		            <div class="imgContaienr">
		                <div class="con">
<img 
  v-if="lent.real_fan !== ``" 
  :src="lent.real_fan" 
  style="width: 100px; height: 90px; cursor: pointer"
  @click="handlePreview(lent.real_fan)"
/>		                    <a v-else class="placeText">请选择图片</a>
		                </div>
		            </div>
		        </a-col>
		        <a-col :xs="24" :md="8" :lg="8" :xl="14">
		            <div class="btnCon">
		                <input @change="handleChanges" type="file" accept="image/*" />
		                <a-button-group>
		                    <a-button type="primary">选择图片</a-button>
		                </a-button-group>
		            </div>
		        </a-col>
		    </a-row>
		</a-form-item>
            <!-- <div>信用分:</div>
            <a-input v-model="lent.dit" placeholder="请输入信用分" style="margin: 10px 0" /> -->
            <div>余额:</div>
            <a-input v-model="lent.price" placeholder="请输入余额" style="margin: 10px 0" />
            <template slot="footer">
                <a-button-group>
                    <a-button type="primary" :loading="btnloading" @click="GetPasswordOne()">确定</a-button>
                    <a-button type="default" @click="Password = false">关闭</a-button>
                </a-button-group>
            </template>
			
        </a-modal>
		
    </PageView>
</template>

<script type="text/jsx">
import User from '../../api/User.js'
import { mapGetters } from 'vuex'
import Home from '../../api/Home.js'

export default {
    name: 'memberList',
    data () {
        return {
            loading: true,
			visible1: false,
			visible:false,
			viewImg: '',
            Password: false,
            lent:{
              id:'',
              name:'',
              username:'',
              dit:'',
              phone:'',
              price:'',
			  real_zheng:'',
			  real_fan:'',
            },
            columns: [
                {
                    title: '头像',
                    dataIndex: 'img',
                    customRender:(v)=>{
                        return <img style="display:block;height:40px" src={v}/>
                    }
                },
				{
				    title: '二维码',
				    dataIndex: 'qrcode',
				    customRender: (v) => {
				        return v ? <img src={v} style="width:100px;height:100px;cursor: pointer" alt="" onClick={() => {
				            this.visible = true;
				            this.viewImg = v;
				        }
				        } /> : '暂无'
				    }
				},
                {
                    title: '姓名',
                    dataIndex: 'name',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '昵称',
                    dataIndex: 'username',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '手机号',
                    dataIndex: 'phone',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                // {
                //     title: '账户余额',
                //     dataIndex: 'price',
                //     customRender: (v) => {
                //         return v || '空'
                //     }
                // },
                // {
                //     title: '信用分',
                //     dataIndex: 'dit',
                //     customRender: (v) => {
                //         return v || '空'
                //     }
                // },
                // {
                //     title: '省',
                //     dataIndex: 'pro_name',
                //     customRender: (v) => {
                //         return v || '空'
                //     }
                // },
                // {
                //     title: '市',
                //     dataIndex: 'city_name',
                //     customRender: (v) => {
                //         return v || '空'
                //     }
                // },
                // {
                //     title: '区县',
                //     dataIndex: 'area_name',
                //     customRender: (v) => {
                //         return v || '空'
                //     }
                // },
                // {
                //     title: '详细地址',
                //     dataIndex: 'add_ress',
                //     customRender: (v) => {
                //         return v || '空'
                //     }
                // },
                {
                    title: '是否拉黑',
                    customRender: (v) => {
                        if(v.status == 1){
                            return '否'
                        }else if(v.status == 2){
                            return '是'
                        }
                    }
                },
                {
                    title: '注册时间',
                    dataIndex: 'add_time',
                    customRender: (v) => {
                        return v?this.timeOne(v):'空'
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    {v.status == 1 ? (
                                        <a-menu-item onClick={() => this.changeConfig(v.id, 'blockUser', '拉黑用户')}>拉黑用户</a-menu-item>
                                    ) : <a-menu-item onClick={() => this.changeConfig(v.id, 'unblockUser', '解除拉黑')}>解除拉黑</a-menu-item>}
                                    <a-menu-item onClick={() => {
                                        this.GetPassword(v)
                                    }}>修改个人信息
                                    </a-menu-item>
                                    <a-menu-item onClick={() => {
                                        this.saveGudong(v)
                                    }}>删除
                                    </a-menu-item>
                                </a-menu>
                                <a-button>操作 <a-icon type="down"/></a-button>
                            </a-dropdown>
                        )
                    }
                }
            ],
            data: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            searchData: {
                username: '',
                name: '',
                phone: '',
            },
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            btnloading: false,
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
        }
    },
    activated () {
        this.getList()
    },
    methods: {
		 handlePreview(imgUrl) {
		    this.visible = true
		    this.viewImg = imgUrl
		  },
		handleChange(e) {
		    let file = e.target.files[0]
		    let reader = new FileReader()
		    reader.onload = () => {
		        Home.upload({ img: reader.result }).then(res => {
					this.lent.real_zheng= res.result
		        })
		        reader.onload = null
		    }
		    reader.readAsDataURL(file)
		},
		handleChanges(e) {
		    let file = e.target.files[0]
		    let reader = new FileReader()
		    reader.onload = () => {
		        Home.upload({ img: reader.result }).then(res => {
					this.lent.real_fan= res.result
		        })
		        reader.onload = null
		    }
		    reader.readAsDataURL(file)
		},
        ...mapGetters(['nickid']),
        getListInit(){
        this.searchData.phone = ''
        this.searchData.username = ''
        this.searchData.name = ''
        this.current = 1
        this.getList()
      },
      changeConfig(id, methods, title){
            this.$confirm({
                title: `${title}`,
                content: `确定要${title}吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        User[methods]({ id: id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        getList () {
            this.loading = true
            User.user_list({
                page: this.current,
                num: this.pageSize,
                ...this.searchData,
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        GetPassword (e) {
            this.lent.name = e.name
            this.lent.id = e.id
            this.lent.username = e.username
            this.lent.dit = e.dit
            this.lent.phone = e.phone
            this.lent.price = e.price
			this.lent.real_zheng = e.real_zheng
			this.lent.real_fan = e.real_fan
			
            this.Password = true
        },
        GetPasswordOne () {
           User.SaveUser({
            id:this.lent.id,
            name:this.lent.name,
            username:this.lent.username,
            dit:this.lent.dit,
            phone:this.lent.phone,
			real_zheng:this.lent.real_zheng,
			real_fan:this.lent.real_fan,
            price:this.lent.price,
             }).then(res => {
                    this.getList()
                    this.Password = false
                })
        },
        changePagination (pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },
        saveGudong (data) {
            this.$confirm({
                title: `提示`,
                content: `确定要删除此会员吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        User.DelteUser({ id:data.id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        //导出的方法
        exportExcel () {
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../excel/Export2Excel')
                const tHeader = this.columns.map(v => v.title)
                const filterVal = this.columns.map(v => v.dataIndex)
                const list = JSON.parse(JSON.stringify(this.data)).map(v => {
                    return v
                })
                const data = this.formatJson(filterVal, list)
                export_json_to_excel(tHeader, data, '会员列表')
            })
        },

        formatJson (filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        }
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}

.radioTitle {
    display: block;
    font-size: 18px;
    padding: 20px 0px;
}

.radioStyle {
    display: block;
    height: 30px;
    lineheight: 30px;
    margin-left: 20px;
}
</style>
